var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 64,
    viewBox: "0 0 96 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.05,
    width: 96,
    height: 64,
    rx: 8,
    fill: "#E0E0E0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.8931 24.6551C57.7776 24.213 56.5985 23.9912 55.4112 24C51.5718 24 48.8602 26.1037 48.841 29.1236C48.817 31.3421 50.7679 32.5924 52.2437 33.3336C53.7579 34.0958 54.2642 34.576 54.2594 35.2573C54.2498 36.2935 53.05 36.7633 51.9341 36.7633C50.4008 36.7633 49.5633 36.531 48.2747 35.9489L47.7972 35.7062L47.2525 39.1828C48.1859 39.6056 49.8681 39.9684 51.6054 39.9998C55.6872 39.9998 58.3556 37.9091 58.3868 34.6961C58.4204 32.9238 57.3645 31.5849 55.1425 30.4782C53.7915 29.7604 52.954 29.2802 52.954 28.552C52.954 27.9073 53.6715 27.2182 55.1713 27.2182C56.1694 27.192 57.1614 27.3957 58.082 27.8159L58.442 27.9908L58.9867 24.6316L58.8931 24.6551ZM68.8564 24.2819H65.8569C64.9234 24.2819 64.2203 24.5612 63.8124 25.5687L58.0436 39.7831H62.1254L62.9413 37.4523L67.923 37.4575C68.0405 38.003 68.4005 39.7831 68.4005 39.7831H71.9999L68.8564 24.2819ZM43.3194 24.1514H47.2093L44.776 39.6604H40.891L43.3194 24.1462V24.1514ZM33.4449 32.6994L33.8481 34.8527L37.6491 24.2819H41.7693L35.6478 39.7622H31.5372L28.1777 26.6545C28.1233 26.4383 27.9955 26.2527 27.8202 26.135C26.6093 25.4547 25.3263 24.9384 23.9999 24.5977L24.0527 24.2715H30.3134C31.1629 24.308 31.8468 24.5977 32.0747 25.5843L33.4425 32.7072V32.6994H33.4449ZM64.0571 34.2811L65.6073 29.9431C65.5881 29.9901 65.9265 29.0479 66.1232 28.4658L66.3896 29.8048L67.2894 34.2785H64.0547V34.2811H64.0571Z",
    fill: "#E0E0E0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_491"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(24 8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/Visa.ca809566be6c7e1a463f0cc4fd5781bb.svg";
export { ForwardRef as ReactComponent };